module.exports = __webpack_public_path__ + "7c4de0b83d9817b27d442a6a2e61156c.pdf";